WiseMetering.Views.WiseApiIntegrationsTable = WiseMetering.Views.TableIndex.extend({
    icon: 'integrations',
    name: () => 'wise_api',

    createTable: function() {
        this.collection = this.model.integrations();

        this.table = new WiseMetering.Views.Table({
            id: 'integrations',
            collection: this.collection,
            disableSelect: !WiseMetering.currentUser.isSuperUser(),
            modelSerializer: model => {
                let
                    color = 'orange',
                    state = model.get('state');

                if (state === 'active') {
                    color = 'green';
                }

                return {
                    id: model.id,
                    bms: i18next.t(`common.${model.get('bms') ? 'yes' : 'no'}`),
                    name: model.get('name'),
                    configurationName: model.configuration() ? model.configuration().get('name') : '-',
                    siteName: model.site() ? model.site().get('name') : '-',
                    rate: model.get('rate') ? `${model.get('rate')}s` : '-',
                    updatedAt: WiseMetering.utils.formatDate(model.get('updated_at')),
                    state: { color, state }
                };
            },
            columns: {
                state: {
                    mRender: ({ color, state }) => JST['templates/ui/components/circle']({
                        color: WiseMetering.SemaphorColors[color],
                        title: state.capitalize()
                    }),
                    sWidth: '20px'
                },
                name: i18next.t('common.name'),
                configurationName: i18next.t('glossary.configuration'),
                siteName: i18next.t('glossary.site'),
                bms: `${i18next.t('integrations.wise_api.bms')}?`,
                rate: i18next.t('integrations.wise_api.rate'),
                updatedAt: i18next.t('glossary.last_change')
            },
            // No disable/enable: the API forbids them for wise_api grants. Access is
            // revoked by deleting the grant or deactivating the configuration.
            toolbar_actions: {
                new: {
                    label: i18next.t('ui.actions.new'),
                    permission: 'superuser',
                    view_call: () => new WiseMetering.Views.NewWiseApiIntegration({
                        collection: WiseMetering.integrations,
                        license: this.model,
                        model: new WiseMetering.Model.Integration({ license_id: this.model.id })
                    })
                },
                edit: {
                    label: i18next.t('ui.actions.edit'),
                    permission: 'superuser',
                    view_call: model => new WiseMetering.Views.EditWiseApiIntegration({ model })
                },
                show: {
                    label: i18next.t('ui.actions.show'),
                    view_call: model => new WiseMetering.Views.ShowWiseApiIntegration({ model })
                },
                delete: {
                    permission: 'superuser',
                    view_call: model => new WiseMetering.Views.Modal.DestroyExtraConfirmation({
                        model,
                        title: () => i18next.t('modal.title.integrations.destroy')
                    })
                }
            }
        });

        $(this.body.el).html(this.table.el);
    },

    onClose: function() {
        this.stopListening(WiseMetering.integrations);

        if (this.table && this.table.remove && typeof (this.table.remove) === 'function') {
            this.table.remove();
        }
    },

    onShow: function() {
        this.listenTo(WiseMetering.integrations, 'remove add change', this.createTable.bind(this));

        this.createTable();
    }
});
